export const UNIVERSITIES = [
  "American University",
  "Amherst College",
  "Arizona State University",
  "Auburn University",
  "Barnard College",
  "Baylor University",
  "Boston College",
  "Boston University",
  "Bowdoin College",
  "Brandeis University",
  "Brown University",
  "Bucknell University",
  "Carnegie Mellon University",
  "Case Western Reserve University",
  "Claremont McKenna College",
  "Clark University",
  "Colby College",
  "Colgate University",
  "College of William & Mary",
  "Colorado College",
  "Columbia University",
  "Connecticut College",
  "Cornell University",
  "Dartmouth College",
  "Davidson College",
  "DePaul University",
  "Drexel University",
  "Duke University",
  "Emory University",
  "Florida State University",
  "Fordham University",
  "George Washington University",
  "Georgetown University",
  "Georgia Institute of Technology",
  "Grinnell College",
  "Hamilton College",
  "Harvard University",
  "Harvey Mudd College",
  "Indiana University",
  "Johns Hopkins University",
  "Lafayette College",
  "Lehigh University",
  "Macalester College",
  "Middlebury College",
  "MIT",
  "Michigan State University",
  "New York University",
  "Northeastern University",
  "Northwestern University",
  "Notre Dame",
  "Oberlin College",
  "Ohio State University",
  "Penn State University",
  "Pomona College",
  "Princeton University",
  "Purdue University",
  "Reed College",
  "Rensselaer Polytechnic Institute",
  "Rice University",
  "Rutgers University",
  "Santa Clara University",
  "Scripps College",
  "Skidmore College",
  "Smith College",
  "Southern Methodist University",
  "Stanford University",
  "Swarthmore College",
  "Syracuse University",
  "Texas A&M University",
  "Trinity College",
  "Tufts University",
  "Tulane University",
  "UC Berkeley",
  "UC Davis",
  "UC Irvine",
  "UC San Diego",
  "UC Santa Barbara",
  "UCLA",
  "UNC Chapel Hill",
  "University of Chicago",
  "University of Colorado Boulder",
  "University of Connecticut",
  "University of Florida",
  "University of Georgia",
  "University of Illinois Urbana-Champaign",
  "University of Maryland",
  "University of Miami",
  "University of Michigan",
  "University of Minnesota",
  "University of North Carolina",
  "University of Notre Dame",
  "University of Pennsylvania",
  "University of Pittsburgh",
  "University of Rochester",
  "University of Southern California",
  "University of Texas at Austin",
  "University of Virginia",
  "University of Washington",
  "University of Wisconsin-Madison",
  "Vanderbilt University",
  "Vassar College",
  "Villanova University",
  "Virginia Tech",
  "Wake Forest University",
  "Washington and Lee University",
  "Washington University in St. Louis",
  "Wellesley College",
  "Wesleyan University",
  "Williams College",
  "Yale University",
];
